import React from 'react'

import Group from 'components/utils/Group'

type Props = {
  children: React.ReactNode
}

function ModalFooterActionContainer({ children }: Props) {
  return (
    <Group
      direction="vertical-reverse"
      gap={8}
      tabletDirection="horizontal"
      tabletHorizontalAlign="end"
    >
      {children}
    </Group>
  )
}

export default ModalFooterActionContainer
